import * as signalR from '@microsoft/signalr';
import { SIGNALR_ACTION } from '../../utilities/constants';
import { client } from '../constructionPlacement';

//ref: https://stackoverflow.com/questions/59652214/how-do-i-add-custom-headers-to-signalrs-typescript-client/63157626#63157626
export default class CustomHttpClient extends signalR.DefaultHttpClient {
  constructor() {
    super(console);
  }
  send(request) {
    const headers = {
      'X-WebSocket-Request-Id': client.getWebSocketRequestId(
        SIGNALR_ACTION.NEGOTIATE
      ),
    };
    request.headers = { ...request.headers, ...headers };
    return super.send(request);
  }
}



// WEBPACK FOOTER //
// ./src/canvas/common/custom-httpclient.js